function getFocusableElements(t) {
  return Array.from(
    t.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
let isSddBannerClicked = false;
document.querySelectorAll('[id^="Details-"] summary').forEach((t) => {
  (t.setAttribute("role", "button"),
    t.setAttribute("aria-expanded", t.parentNode.hasAttribute("open")),
    t.nextElementSibling.getAttribute("id") &&
      t.setAttribute("aria-controls", t.nextElementSibling.id),
    (this.mql = window.matchMedia("(min-width: 990px)")),
    !mql.matches &&
      t.addEventListener("click", (t) => {
        if (
          t.currentTarget.id.startsWith("HeaderMenu-") &&
          !t.currentTarget.closest("details").hasAttribute("open")
        ) {
          let e = t.currentTarget.parentNode;
          for (; e && "UL" !== e.nodeName; ) e = e.parentNode;
          !(function t(e, i) {
            Array.from(e.children).forEach((e) => {
              ("DETAILS" === e.nodeName &&
                e !== i &&
                e.hasAttribute("open") &&
                (e.removeAttribute("open"), e.classList.remove("menu-opening")),
                t(e, i));
            });
          })(e, t.currentTarget.closest("details"));
        }
        t.currentTarget.setAttribute(
          "aria-expanded",
          !t.currentTarget.closest("details").hasAttribute("open"),
        );
      }),
    mql.matches &&
      t.addEventListener("mouseover", (t) => {
        if (
          t.currentTarget.id.startsWith("HeaderMenu-") &&
          !t.currentTarget.closest("details").hasAttribute("open")
        ) {
          t.currentTarget.closest("details").setAttribute("open", "");
          let e = t.currentTarget.parentNode;
          for (; e && "UL" !== e.nodeName; ) e = e.parentNode;
          (!(function t(e, i) {
            Array.from(e.children).forEach((e) => {
              ("DETAILS" === e.nodeName &&
                e !== i &&
                e.hasAttribute("open") &&
                (e.removeAttribute("open"), e.classList.remove("menu-opening")),
                t(e, i));
            });
          })(e, t.currentTarget.closest("details")),
            t.currentTarget.setAttribute(
              "aria-expanded",
              t.currentTarget.closest("details").hasAttribute("open"),
            ));
        }
      }),
    mql.matches &&
      t.addEventListener("mouseout", (t) => {
        t.currentTarget.id.startsWith("HeaderMenu-") &&
          t.currentTarget.closest("details").hasAttribute("open") &&
          !t.relatedTarget.closest("header-menu") &&
          (t.currentTarget
            .closest("header-menu")
            .querySelectorAll("details")[0]
            .removeAttribute("open"),
          t.currentTarget
            .closest("header-menu")
            .querySelectorAll("details")[0]
            .querySelectorAll("summary")[0]
            .setAttribute("aria-expanded", "false"));
      }),
    mql.matches &&
      t.nextElementSibling.addEventListener("mouseout", (t) => {
        t.currentTarget.id.startsWith("HeaderMenu-") &&
          !t.relatedTarget.closest("header-menu") &&
          (t.currentTarget
            .closest("header-menu")
            .querySelectorAll("details")[0]
            .removeAttribute("open"),
          t.currentTarget
            .closest("header-menu")
            .querySelectorAll("details")[0]
            .querySelectorAll("summary")[0]
            .setAttribute("aria-expanded", "false"));
      }),
    t.closest("header-drawer, menu-drawer") ||
      t.parentElement.addEventListener("keyup", onKeyUpEscape));
});
const trapFocusHandlers = {};
function trapFocus(t, e = t) {
  var i = getFocusableElements(t),
    s = i[0],
    n = i[i.length - 1];
  (removeTrapFocus(),
    (trapFocusHandlers.focusin = (e) => {
      (e.target !== t && e.target !== n && e.target !== s) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (e) {
      "TAB" === e.code.toUpperCase() &&
        (e.target !== n || e.shiftKey || (e.preventDefault(), s.focus()),
        (e.target !== t && e.target !== s) ||
          !e.shiftKey ||
          (e.preventDefault(), n.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    e && e.focus(),
    e &&
      "INPUT" === e.tagName &&
      ["search", "text", "email", "url"].includes(e.type) &&
      e.value &&
      e.setSelectionRange(0, e.value.length));
}
try {
  document.querySelector(":focus-visible");
} catch (t) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const t = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let e = null,
    i = null;
  (window.addEventListener("keydown", (e) => {
    t.includes(e.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener("mousedown", (t) => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        (e && e.classList.remove("focused"),
          i || ((e = document.activeElement), e.classList.add("focused")));
      },
      !0,
    ));
}
function pauseAllMedia() {
  (document.querySelectorAll(".js-youtube").forEach((t) => {
    t.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*",
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((t) => {
      t.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((t) => t.pause()),
    document.querySelectorAll("product-model").forEach((t) => {
      t.modelViewerUI && t.modelViewerUI.pause();
    }));
}
function removeTrapFocus(t = null) {
  (document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    t && t.focus());
}
function onKeyUpEscape(t) {
  if ("ESCAPE" !== t.code.toUpperCase()) return;
  const e = t.target.closest("details[open]");
  if (!e) return;
  const i = e.querySelector("summary");
  (e.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus());
}
document.querySelectorAll(".cust_del_address").forEach((t) => {
  if (
    localStorage.getItem("selectedDeliveryAddress") &&
    t
      .closest(".del-pincode-address-option")
      .querySelector(".cust_del_address_id") &&
    localStorage.getItem("selectedDeliveryAddress") ==
      t
        .closest(".del-pincode-address-option")
        .querySelector(".cust_del_address_id").value
  ) {
    document.querySelectorAll(".del-pincode-address-option").forEach((t) => {
      t.classList.remove("del-selected");
    });
    t.closest(".del-pincode-address-option").classList.add("del-selected");
    document.querySelector(".pincode_input").value = t.value;
    checkSameDayDelivery();
  }
  t.addEventListener("change", async (e) => {
    const i = e.target.closest(".del-pincode-address-option");
    if (i) {
      document.querySelectorAll(".del-pincode-address-option").forEach((t) => {
        t.classList.remove("del-selected");
      });
      i.classList.add("del-selected");
      document.querySelector(".pincode_input").value = e.target.value;
      localStorage.setItem(
        "selectedDeliveryAddress",
        i.querySelector(".cust_del_address_id").value,
      );
      localStorage.setItem("sddPincode", e.target.value);
      localStorage.setItem("sddUserId", __st.cid);
    }
  });
});
document
  .querySelector(".pincode_overlay .icon-close")
  .addEventListener("click", () => {
    document.querySelector(".pincode_overlay").style.display = "none";
    document.querySelector(".shopify-section-group-header-group").style.zIndex =
      4;
    isSddBannerClicked = false;
  });
document
  .querySelector(".pincode_overlay")
  .addEventListener("click", function (e) {
    const content = document.querySelector(".pincode_overlay_content");
    if (!content.contains(e.target)) {
      this.style.display = "none";
      document.querySelector(
        ".shopify-section-group-header-group",
      ).style.zIndex = 4;
      isSddBannerClicked = false;
    }
  });

async function getMarketingUserIdWithRetry(maxRetries = 15, delay = 500) {
  for (let i = 0; i < maxRetries; i++) {
    const found = dataLayer.find((e) => e.marketing && e.marketing.user_id);
    if (found && found.marketing && found.marketing.user_id) {
      return found.marketing.user_id;
    }
    await new Promise((resolve) => setTimeout(resolve, delay));
  }
  throw new Error("marketing.user_id not found in dataLayer after retries");
}

let sddPincode = "";
let showCustomCart = "";
window.visitor_id = getMarketingUserIdWithRetry();

document.addEventListener("DOMContentLoaded", async () => {
  document.querySelectorAll(".header_pincode_box").forEach((t) => {
    t.addEventListener("click", (e) => {
      firePincodeClickEvent();
      document.querySelector(".pincode_overlay").style.display = "flex";
      document.querySelector(
        ".shopify-section-group-header-group",
      ).style.zIndex = 1;
    });
  });
  const pincodeInput = document.querySelector(".pincode_input");
  const pincodeSubmitButton = document.querySelector(".pincode_submit_button");
  if (
    __st.cid &&
    localStorage.getItem("sddUserId") &&
    localStorage.getItem("sddUserId") == __st.cid
  ) {
    if (localStorage.getItem("sddPincode")) {
      document.querySelector(".pincode_input").value =
        localStorage.getItem("sddPincode");
    } else {
      document.querySelector(".pincode_input").value = custZip || "";
    }
  }
  function togglePincodeButton() {
    if (pincodeInput.value.trim().length === 0) {
      pincodeSubmitButton.setAttribute("disabled", "disabled");
    } else {
      pincodeSubmitButton.removeAttribute("disabled");
    }
  }
  pincodeInput.addEventListener("input", togglePincodeButton);
  togglePincodeButton();
  const cartPincodeFromStorage = localStorage.getItem("cartPincode");
  if (cartPincodeFromStorage && cartPincodeFromStorage.trim().length > 0) {
    sddPincode = cartPincodeFromStorage;
    localStorage.setItem("sddPincode", sddPincode);
  } else if (document.getElementById("pincode_input").value.trim().length > 0) {
    sddPincode = document.getElementById("pincode_input").value;
  } else {
    sddPincode = localStorage.getItem("sddPincode");
  }
  if (sddPincode && sddPincode.length > 0) {
    document.getElementById("pincode_input").value = sddPincode;
    checkSameDayDelivery({
      preferCart: !!(
        cartPincodeFromStorage && cartPincodeFromStorage.trim().length > 0
      ),
    });
  } else {
    // if (
    //   (window.location.pathname === "/" ||
    //     window.location.href.includes("collections")) &&
    //   !sessionStorage.getItem("pincodeAsked")
    // ) {
    //   document.querySelector(".pincode_overlay").style.display = "flex";
    //   document.querySelector(
    //     ".shopify-section-group-header-group",
    //   ).style.zIndex = 1;
    //   sessionStorage.setItem("pincodeAsked", true);
    // }
    let sddBanner = document.querySelector(".banner-sdd-box");
    let sddBannerSlide = document.querySelectorAll(".sdd-banner-slide");
    if (sddBanner) {
      window.sddBannerClickHandler = function (e) {
        e.preventDefault();
        document.querySelector(".pincode_overlay").style.display = "flex";
        document.querySelector(
          ".shopify-section-group-header-group",
        ).style.zIndex = 1;
        isSddBannerClicked = true;
      };
      sddBanner.addEventListener("click", window.sddBannerClickHandler);
    }
    if (sddBannerSlide.length > 0) {
      sddBannerSlide.forEach((banner) => {
        if (!banner._sddBannerSlideClickHandler) {
          banner._sddBannerSlideClickHandler = function (e) {
            e.preventDefault();
            document.querySelector(".pincode_overlay").style.display = "flex";
            document.querySelector(
              ".shopify-section-group-header-group",
            ).style.zIndex = 1;
            isSddBannerClicked = true;
          };
          banner.addEventListener("click", banner._sddBannerSlideClickHandler);
        }
      });
    }
  }

  // Custom cart check logic
  const now = Date.now();
  let showCustomCartFromStorage = localStorage.getItem("showCustomCart");
  let userIdFromStorage = localStorage.getItem("showCustomCartUserId");
  let showCustomCartExpiry = parseInt(
    localStorage.getItem("showCustomCartExpiry"),
    10,
  );
  let customer_id;
  if (
    !showCustomCartFromStorage ||
    !showCustomCartExpiry ||
    !userIdFromStorage ||
    now > showCustomCartExpiry ||
    (__st.cid && userIdFromStorage != __st.cid)
  ) {
    try {
      if (__st.cid) {
        customer_id = __st.cid;
      } else {
        customer_id = await window.visitor_id;
      }
      let refId = await generateCustomCartRefId();
      const response = await fetch(
        `https://prod-bifrost.giva-api.com/api/cart/config`,
        {
          headers: { ref_access_token: refId },
        },
      );
      const resdata = await response.json();
      showCustomCart = resdata.data.mode == "custom" ? "true" : "false";
      localStorage.setItem("showCustomCart", showCustomCart);
      localStorage.setItem(
        "showCustomCartExpiry",
        (now + 24 * 60 * 60 * 1000).toString(),
      );
      localStorage.setItem("showCustomCartUserId", customer_id);
      setCustomCartElements();
    } catch (err) {
      showCustomCart = "false";
    }
  } else {
    showCustomCart = showCustomCartFromStorage;
    setCustomCartElements();
  }
});
async function setCartItemCount() {
  let data = await fetchCustomCart();
  let count = 0;
  if (data.data) {
    customCartId = data.data.cart.id;
    if (customCartId.length === 0) {
      customCartId = undefined;
    }
    if (data.data.cart?.shipping_address?.zip?.length > 0) {
      localStorage.setItem("cartPincode", data.data.cart.shipping_address.zip);
      checkSameDayDelivery({ preferCart: true });
    } else {
      localStorage.removeItem("cartPincode");
    }
    if (data.data.cart.items.length > 0) {
      count = data.data.cart.items
        .filter((item) => item.item_id != "31471233106010")
        .map((item) => item.quantity)
        .reduce((a, b) => a + b, 0);
    }
  } else {
    localStorage.removeItem("cartPincode");
  }
  document.querySelectorAll(".header__icon--cart").forEach((el) => {
    if (el.getAttribute("id") == "cart-icon-bubble") {
      el.querySelector(".cart-count-bubble").removeAttribute("style");
      el.querySelector(".cart-count-bubble")
        .querySelectorAll("span")
        .forEach((span) => {
          span.innerHTML = count;
        });
    }
  });
  document.querySelectorAll(".header__icon--cart").forEach((el) => {
    if (el.getAttribute("id") == "cart-icon-bubble") {
      el.removeAttribute("style");
    }
  });
}
async function setCustomCartElements() {
  if (showCustomCart == "true") {
    document.querySelectorAll(".header__icon--account-link").forEach((el) => {
      el.setAttribute(
        "href",
        `https://www.giva.co/account/login?return_url=/?loggedInUser=1`,
      );
    });
    let refId = await generateCustomCartRefId();
    document.querySelectorAll(".ghs-page-link").forEach((el) => {
      el.setAttribute(
        "href",
        `https://checkout.giva.co/gold-harvest/new?ref_id=${refId}`,
      );
      el.removeAttribute("style");
    });
    document.querySelectorAll(".bottom-metal-toggle-bar a").forEach((el) => {
      if (el.getAttribute("href") == "/account") {
        el.setAttribute(
          "href",
          `https://www.giva.co/account/login?return_url=/?loggedInUser=1`,
        );
      }
    });
    if (
      window.location.pathname === "/account" &&
      document.querySelector(".custom-flow")
    ) {
      document.querySelector(".custom-flow").removeAttribute("style");
      document.querySelector("#reco-loader").style.display = "none";
    }
    setCartItemCount();
    document.querySelectorAll(".header__icon--cart").forEach((el) => {
      if (el.getAttribute("id") == "cart-icon-bubble") {
        el.addEventListener("click", async (e) => {
          e.preventDefault();
          const href = e.currentTarget.getAttribute("href");
          if (!href.split("?ref_id=")[1]) {
            let userIdForCart = __st.cid ? __st.cid : null;
            let sessionIdForCart = await window.visitor_id;
            let gclid =
              new URLSearchParams(window.location.search).get("gclid") || null;
            let fbclid =
              new URLSearchParams(window.location.search).get("fbclid") || null;
            let customCartUrl = `https://checkout.giva.co/cart?ref_id=${refId}&${userIdForCart ? `user_id=${userIdForCart}&` : ""}${sessionIdForCart ? `session_id=${sessionIdForCart}&` : ""}${gclid ? `gclid=${gclid}&` : ""}${fbclid ? `fbclid=${fbclid}&` : ""}`;
            document.querySelectorAll(".header__icon--cart").forEach((el) => {
              if (el.getAttribute("id") == "cart-icon-bubble") {
                el.setAttribute("href", customCartUrl);
              }
            });
            window.location.href = customCartUrl;
          } else {
            window.location.href = href;
          }
        });
      }
    });
  } else {
    document.querySelectorAll(".header__icon--cart").forEach((el) => {
      if (el.getAttribute("id") == "cart-icon-bubble") {
        el.removeAttribute("style");
        el.querySelector("#cart-count-bubble").removeAttribute("style");
      }
    });
    let refId = await generateRefId();
    document.querySelectorAll(".ghs-page-link").forEach((el) => {
      el.setAttribute(
        "href",
        `https://checkout.giva.co/gold-harvest/new?ref_id=${refId}`,
      );
      el.removeAttribute("style");
    });
    if (
      window.location.pathname === "/account" &&
      document.querySelector(".normal-flow")
    ) {
      document.querySelector(".normal-flow").removeAttribute("style");
      document.querySelector("#reco-loader").style.display = "none";
    }
  }
}
document
  .querySelector(".pincode_submit_button")
  .addEventListener("click", (e) => {
    if (
      document.querySelector(".del-selected") &&
      document.querySelector(".pincode_input").value !=
        document.querySelector(".del-selected .cust_del_address").value
    ) {
      localStorage.removeItem("selectedDeliveryAddress");
      localStorage.setItem(
        "sddPincode",
        document.querySelector(".pincode_input").value,
      );
      document.querySelectorAll(".del-pincode-address-option").forEach((t) => {
        t.classList.remove("del-selected");
      });
    }
    firePincodeEnterEvent(document.querySelector(".pincode_input").value);
    e.target.innerHTML = "Updating...";
    e.target.setAttribute("disabled", "disabled");
    checkSameDayDelivery();
    document.querySelector(".banner-sdd-box") &&
      document
        .querySelector(".banner-sdd-box")
        .removeEventListener("click", window.sddBannerClickHandler);
    document.querySelectorAll(".sdd-banner-slide").forEach((banner) => {
      banner.removeEventListener("click", banner._sddBannerSlideClickHandler);
    });
  });
async function generateRefId() {
  const currUtmSource = localStorage.getItem("utm_source");
  const currUtmMedium = localStorage.getItem("utm_medium");
  let payload = {
    user_shopify_id: null,
    user_email: null,
    visitor_id: await window.visitor_id,
    metadata: {
      utm_source: currUtmSource,
      utm_medium: currUtmMedium,
    },
  };
  let now = Date.now();
  let refId = localStorage.getItem("REF_ID_KEY");
  let refIdUser = localStorage.getItem("REF_ID_USER");
  let refIdExpiry =
    parseInt(localStorage.getItem("REF_ID_EXPIRY_KEY"), 10) || 0;
  let refIdUtmSource = localStorage.getItem("REF_ID_UTM_SOURCE");
  let refIdUtmMedium = localStorage.getItem("REF_ID_UTM_MEDIUM");
  const currentUser = __st.cid ? String(__st.cid) : "non loggedin user";
  const utmChanged =
    currUtmSource !== refIdUtmSource || currUtmMedium !== refIdUtmMedium;
  if (!refId || now > refIdExpiry || refIdUser !== currentUser || utmChanged) {
    if (__st.cid) {
      await fetch(
        `/apps/sdd-proxy?visitor_id=${payload.visitor_id}&metadata=${encodeURIComponent(JSON.stringify(payload.metadata))}`,
      )
        .then((res) => res.json())
        .then((data) => {
          refId = data.data;
        });
    } else {
      await fetch("https://api.givadiva.co/v2/features/mto/mtoWebTemp", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          refId = data.data;
        });
    }
    if (!refId) return null;
    now = Date.now();
    localStorage.setItem("REF_ID_KEY", refId);
    localStorage.setItem("REF_ID_USER", currentUser);
    localStorage.setItem("REF_ID_UTM_SOURCE", currUtmSource || "");
    localStorage.setItem("REF_ID_UTM_MEDIUM", currUtmMedium || "");
    localStorage.setItem(
      "REF_ID_EXPIRY_KEY",
      (now + 10 * 60 * 1000).toString(),
    );
  }
  return refId;
}
function parseStoredValue(value) {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return value; // plain string like "google"
  }
}
async function generateCustomCartRefId() {
  const currUtmSource = localStorage.getItem("utm_source");
  const currUtmMedium = localStorage.getItem("utm_medium");

  let payload = {
    user_shopify_id: null,
    user_email: null,
    visitor_id: await window.visitor_id,
    metadata: {
      ...(currUtmSource != null && {
        utm_source: parseStoredValue(currUtmSource),
      }),
      ...(currUtmMedium != null && { utm_medium: currUtmMedium }),
      marketing:
        window.dataLayer.find((item) => item.marketing)?.marketing || {},
    },
  };

  let now = Date.now();
  let refId = localStorage.getItem("CUSTOM_REF_ID_KEY");
  let refIdUser = localStorage.getItem("CUSTOM_REF_ID_USER");
  let refIdExpiry =
    parseInt(localStorage.getItem("CUSTOM_REF_ID_EXPIRY_KEY"), 10) || 0;
  let refIdUtmSource = localStorage.getItem("CUSTOM_REF_ID_UTM_SOURCE");
  let refIdUtmMedium = localStorage.getItem("CUSTOM_REF_ID_UTM_MEDIUM");
  const currentUser = __st.cid ? String(__st.cid) : "non loggedin user";
  const utmChanged =
    currUtmSource !== refIdUtmSource || currUtmMedium !== refIdUtmMedium;
  if (!refId || now > refIdExpiry || refIdUser !== currentUser || utmChanged) {
    const params = new URLSearchParams({
      visitor_id: String(payload.visitor_id),
      metadata: JSON.stringify(payload.metadata), // URLSearchParams encodes this
    });
    if (__st.cid) {
      await fetch(`/apps/custom-cart-proxy?${params.toString()}`)
        .then((res) => res.json())
        .then((data) => {
          refId = data.data;
        });
    } else {
      await fetch(
        `https://prod-bifrost.giva-api.com/api/user/visitor-token?${params.toString()}`,
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          refId = data.data;
        });
    }
    if (!refId) return null;
    now = Date.now();
    localStorage.setItem("CUSTOM_REF_ID_KEY", refId);
    localStorage.setItem("CUSTOM_REF_ID_USER", currentUser);
    localStorage.setItem("CUSTOM_REF_ID_UTM_SOURCE", currUtmSource || "");
    localStorage.setItem("CUSTOM_REF_ID_UTM_MEDIUM", currUtmMedium || "");
    localStorage.setItem(
      "CUSTOM_REF_ID_EXPIRY_KEY",
      (now + 10 * 60 * 1000).toString(),
    );
  }
  return refId;
}
async function notifyLogin(redirect, cartId = null) {
  let refId = await generateCustomCartRefId();
  fetch(`https://prod-bifrost.giva-api.com/api/cart/notify-login`, {
    method: "POST",
    body: JSON.stringify({ cart_id: cartId }),
    headers: {
      "Content-Type": "application/json",
      ref_access_token: refId,
    },
  })
    .then((response) => response.json())
    .then(async (data) => {
      document.querySelectorAll(".header__icon--cart").forEach((el) => {
        if (el.getAttribute("id") == "cart-icon-bubble") {
          el.querySelector(".cart-count-bubble").removeAttribute("style");
          el.querySelector(".cart-count-bubble")
            .querySelectorAll("span")
            .forEach((span) => {
              if (data.data && data.data.cart && data.data.cart.items) {
                span.innerHTML = data.data.cart.items
                  .map((item) => item.quantity)
                  .reduce((a, b) => a + b, 0);
              }
            });
        }
      });
      if (redirect) {
        let userIdForCart = __st.cid ? __st.cid : null;
        let sessionIdForCart = await window.visitor_id;
        let gclid =
          new URLSearchParams(window.location.search).get("gclid") || null;
        let fbclid =
          new URLSearchParams(window.location.search).get("fbclid") || null;
        let target =
          new URLSearchParams(window.location.search).get("target") || "cart";
        if (window.location.pathname === "/pages/gold-harvest") {
          target = "gold-harvest";
        }
        let respCartId = data.data.cart.id ? data.data.cart.id : null;
        let customCartUrl = `https://checkout.giva.co/cart?ref_id=${refId}${respCartId ? `&cart_id=${respCartId}` : ""}&${userIdForCart ? `user_id=${userIdForCart}&` : ""}${sessionIdForCart ? `session_id=${sessionIdForCart}&` : ""}${gclid ? `gclid=${gclid}&` : ""}${fbclid ? `fbclid=${fbclid}&` : ""}`;
        if (target !== "cart") {
          customCartUrl = `https://checkout.giva.co/${target}?ref_id=${refId}`;
        }
        window.location.replace(customCartUrl);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      if (redirect) {
        window.location.href = "/";
      }
    });
}
const baseUrl = window.location.origin + window.location.pathname;
if (
  baseUrl === "https://www.giva.co/pages/redirecting" ||
  baseUrl === "https://www.giva.co/pages/gold-harvest"
) {
  (async () => {
    if (showCustomCart == "true") {
      let cartId =
        new URLSearchParams(window.location.search).get("cart_id") || null;
      notifyLogin(true, cartId);
    } else {
      let refId = await generateRefId();
      let target =
        new URLSearchParams(window.location.search).get("target") || null;
      if (baseUrl === "https://www.giva.co/pages/gold-harvest") {
        target = "gold-harvest";
      }
      if (target) {
        let customCartUrl = `https://checkout.giva.co/${target}?ref_id=${refId}`;
        window.location.replace(customCartUrl);
      }
    }
  })();
}
const loginUrlParams = new URLSearchParams(window.location.search);
if (loginUrlParams.get("loggedInUser") == "1") {
  notifyLogin(false);
}
async function checkSameDayDelivery(options = {}) {
  const { preferCart = false } = options;
  const pincodeInputEl = document.querySelector(".pincode_input");
  const inputPincode = pincodeInputEl ? pincodeInputEl.value.trim() : "";
  const cartPincode = localStorage.getItem("cartPincode") || "";
  const storedSddPincode = localStorage.getItem("sddPincode") || "";

  sddPincode = preferCart
    ? cartPincode || inputPincode || storedSddPincode
    : inputPincode || cartPincode || storedSddPincode;

  if (!sddPincode) {
    document.querySelector(".pincode_submit_button").innerHTML = "Update";
    document
      .querySelector(".pincode_submit_button")
      .removeAttribute("disabled");
    return;
  }

  if (pincodeInputEl) {
    pincodeInputEl.value = sddPincode;
  }

  localStorage.setItem("sddPincode", sddPincode);
  if (!preferCart && cartPincode !== sddPincode) {
    localStorage.setItem("cartPincode", sddPincode);
  }

  setTimeout(async () => {
    let refId = await generateRefId();
    getSddScreen({ data: refId });
  }, 2000);
  if (!preferCart) {
    updateCustomCartAddress(sddPincode);
  }
}
let customCartId;
async function updateCustomCartAddress(pincode) {
  if (showCustomCart == "true" && customCartId) {
    let refId = await generateCustomCartRefId();
    let address = {};
    address.zip = pincode;
    let selectedAddr = document.querySelector(".del-selected");
    if (selectedAddr) {
      address.line1 = selectedAddr.querySelector("#customer_addr_line1").value;
      address.line2 = selectedAddr.querySelector("#customer_addr_line2").value;
      address.city = selectedAddr.querySelector("#customer_addr_city").value;
      address.state = selectedAddr.querySelector("#customer_addr_state").value;
      address.country = selectedAddr.querySelector(
        "#customer_addr_country",
      ).value;
    }
    fetch("https://prod-bifrost.giva-api.com/api/cart/update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ref_access_token: refId,
      },
      body: JSON.stringify({
        cart_id: customCartId,
        user_id: __st.cid || (await window.visitor_id),
        entity_type: "fulfillment",
        shipping_address: address,
        billing_address: address,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Cart address update response:", data);
      });
  }
}
async function fetchCustomCart() {
  let refId = await generateCustomCartRefId();
  let resp = await fetch(`https://prod-bifrost.giva-api.com/api/cart/home`, {
    headers: { ref_access_token: refId },
    cache: "no-store",
  });
  if (!resp.ok) {
    console.log("No cart found for user");
  } else {
    const data = await resp.json();
    if (data.data) {
      customCartId = data.data.cart.id;
      if (customCartId.length === 0) {
        customCartId = undefined;
      }
    }
    return data;
  }
  return resp;
}
async function getSddScreen(data) {
  if (data.data && data.data.length > 0) {
    const refId = data.data;
    const now = new Date();
    const days = now.getHours() < 13 ? 0 : 1;
    await fetch(
      `https://api.givadiva.co/apps/productScreen/checkDeliveryEstimations?days=${days}&pincode=${sddPincode}`,
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.data === true) {
          localStorage.setItem("sddAvailable", "true");
          if (typeof checkTransitions === "function") {
            checkTransitions();
          }
        } else {
          localStorage.setItem("sddAvailable", "false");
          document.querySelectorAll(".sdd_text_box").forEach((el) => {
            el.style.display = "none";
          });
        }
        let sddBanner = document.querySelector(".banner-sdd-box");
        let sddBannerSlide = document.querySelectorAll(".sdd-banner-slide");
        if (data.data && data.data === true) {
          const sddUrl = `https://express.giva.co/?ref_id=${refId}&pincode=${sddPincode}`;
          if (sddBanner) {
            Array.from(sddBanner.querySelectorAll(".sdd-banner-link")).forEach(
              (a) => {
                a.setAttribute("href", sddUrl);
              },
            );
          }
          if (sddBannerSlide.length > 0) {
            sddBannerSlide.forEach((banner) => {
              Array.from(banner.getElementsByTagName("a")).forEach((a) => {
                a.setAttribute("href", sddUrl);
              });
            });
          }
          if (document.querySelector("#sdd-fast-delivery-logo")) {
            document.querySelector("#sdd-fast-delivery-logo").style.display =
              "block";
          }
          if (document.querySelector("#sdd-location-logo")) {
            document.querySelector("#sdd-location-logo").style.display = "none";
          }
          if (document.querySelector("#no-sdd-logo")) {
            document.querySelector("#no-sdd-logo").style.display = "none";
          }
          if (document.querySelector("#update-del-text")) {
            document.querySelector("#update-del-text").innerHTML =
              `Fast Delivery to <strong>${sddPincode}</strong>`;
          }
          if (isSddBannerClicked) {
            window.location.href = sddUrl;
          }
        } else {
          if (document.querySelector("#update-del-text")) {
            document.querySelector("#update-del-text").innerHTML =
              `Deliver to <strong>${sddPincode}</strong>`;
          }
          if (document.querySelector("#no-sdd-logo")) {
            document.querySelector("#no-sdd-logo").style.display = "block";
          }
          if (document.querySelector("#sdd-fast-delivery-logo")) {
            document.querySelector("#sdd-fast-delivery-logo").style.display =
              "none";
          }
          if (document.querySelector("#sdd-location-logo")) {
            document.querySelector("#sdd-location-logo").style.display = "none";
          }
          if (sddBanner) {
            Array.from(sddBanner.querySelectorAll(".sdd-banner-link")).forEach(
              (a) => {
                a.setAttribute(
                  "href",
                  "https://www.giva.co/collections/bestsellers",
                );
              },
            );
          }
          if (sddBannerSlide.length > 0) {
            sddBannerSlide.forEach((banner) => {
              Array.from(banner.getElementsByTagName("a")).forEach((a) => {
                a.setAttribute(
                  "href",
                  "https://www.giva.co/collections/bestsellers",
                );
              });
            });
          }
        }
        isSddBannerClicked = false;
        document.querySelector(".pincode_overlay").style.display = "none";
      });
  }
  document.querySelector(".pincode_submit_button").innerHTML = "Update";
  document.querySelector(".pincode_submit_button").removeAttribute("disabled");
}
class QuantityInput extends HTMLElement {
  constructor() {
    (super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((t) =>
        t.addEventListener("click", this.onButtonClick.bind(this)),
      ));
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    (this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this),
      )));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(t) {
    this.validateQtyRules();
  }
  onButtonClick(t) {
    t.preventDefault();
    const e = this.input.value;
    ("plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(),
      e !== this.input.value && this.input.dispatchEvent(this.changeEvent));
  }
  validateQtyRules() {
    const t = parseInt(this.input.value);
    if (this.input.min) {
      const e = parseInt(this.input.min);
      this.querySelector(".quantity__button[name='minus']").classList.toggle(
        "disabled",
        t <= e,
      );
    }
    if (this.input.max) {
      const e = parseInt(this.input.max);
      this.querySelector(".quantity__button[name='plus']").classList.toggle(
        "disabled",
        t >= e,
      );
    }
  }
}
function debounce(t, e) {
  let i;
  return (...s) => {
    (clearTimeout(i), (i = setTimeout(() => t.apply(this, s), e)));
  };
}
function throttle(t, e) {
  let i = 0;
  return function (...s) {
    const n = new Date().getTime();
    if (!(n - i < e)) return ((i = n), t(...s));
  };
}
function fetchConfig(t = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/" + t },
  };
}
(customElements.define("quantity-input", QuantityInput),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (t, e) {
    return function () {
      return t.apply(e, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (t, e) {
    for (var i = 0, s = t.options.length; i < s; i++) {
      var n = t.options[i];
      if (e == n.value || e == n.innerHTML) return ((t.selectedIndex = i), i);
    }
  }),
  (Shopify.addListener = function (t, e, i) {
    t.addEventListener
      ? t.addEventListener(e, i, !1)
      : t.attachEvent("on" + e, i);
  }),
  (Shopify.postLink = function (t, e) {
    var i = (e = e || {}).method || "post",
      s = e.parameters || {},
      n = document.createElement("form");
    for (var r in (n.setAttribute("method", i),
    n.setAttribute("action", t),
    s)) {
      var o = document.createElement("input");
      (o.setAttribute("type", "hidden"),
        o.setAttribute("name", r),
        o.setAttribute("value", s[r]),
        n.appendChild(o));
    }
    (document.body.appendChild(n), n.submit(), document.body.removeChild(n));
  }),
  (Shopify.CountryProvinceSelector = function (t, e, i) {
    ((this.countryEl = document.getElementById(t)),
      (this.provinceEl = document.getElementById(e)),
      (this.provinceContainer = document.getElementById(i.hideElement || e)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this),
      ),
      this.initCountry(),
      this.initProvince());
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var t = this.countryEl.getAttribute("data-default");
      (Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler());
    },
    initProvince: function () {
      var t = this.provinceEl.getAttribute("data-default");
      t &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, t);
    },
    countryHandler: function (t) {
      var e = (n =
          this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces",
        ),
        i = JSON.parse(e);
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var s = 0; s < i.length; s++) {
          var n;
          (((n = document.createElement("option")).value = i[s][0]),
            (n.innerHTML = i[s][1]),
            this.provinceEl.appendChild(n));
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (t) {
      for (; t.firstChild; ) t.removeChild(t.firstChild);
    },
    setOptions: function (t, e) {
      var i = 0;
      for (e.length; i < e.length; i++) {
        var s = document.createElement("option");
        ((s.value = e[i]), (s.innerHTML = e[i]), t.appendChild(s));
      }
    },
  }));
class MenuDrawer extends HTMLElement {
  constructor() {
    (super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents());
    if (this.querySelectorAll(".search-mobile-sort-by").length > 0) {
      this.handleMobileSort();
    }
  }
  bindEvents() {
    (this.querySelectorAll("summary").forEach((t) =>
      t.addEventListener("click", this.onSummaryClick.bind(this)),
    ),
      this.querySelectorAll("button:not(.localization-selector)").forEach((t) =>
        t.addEventListener("click", this.onCloseButtonClick.bind(this)),
      ));
    if (this.querySelector("#close-filter")) {
      this.querySelector("#close-filter").addEventListener(
        "click",
        this.closeMenuDrawer.bind(this),
      );
    }
  }
  handleMobileSort() {
    this.querySelector(".select").addEventListener("click", () => {
      document.querySelector(
        "#retail_search_mob_sort_by_overlay",
      ).style.display = "flex";
    });
    document
      .querySelector("#retail_search_close-sort-by")
      .addEventListener("click", () => {
        document.querySelector(
          "#retail_search_mob_sort_by_overlay",
        ).style.display = "none";
      });
  }
  onKeyUp(t) {
    if ("ESCAPE" !== t.code.toUpperCase()) return;
    const e = t.target.closest("details[open]");
    e &&
      (e === this.mainDetailsToggle
        ? this.closeMenuDrawer(
            t,
            this.mainDetailsToggle.querySelector("summary"),
          )
        : this.closeSubmenu(e));
  }
  closeChildren(t, e) {
    Array.from(t.children).forEach((t) => {
      ("DETAILS" === t.nodeName &&
        t !== e &&
        t.hasAttribute("open") &&
        (t.removeAttribute("open"), t.classList.remove("menu-opening")),
        this.closeChildren(t, e));
    });
  }
  onSummaryClick(t) {
    const e = t.currentTarget,
      i = e.parentNode,
      s = i.closest(".has-submenu"),
      n = i.hasAttribute("open"),
      r = window.matchMedia("(prefers-reduced-motion: reduce)");
    function o() {
      (trapFocus(e.nextElementSibling, i.querySelector("button")),
        e.nextElementSibling.removeEventListener("transitionend", o));
    }
    let a = i;
    for (; a && "UL" !== a.nodeName; ) a = a.parentNode;
    (a && this.closeChildren(a, i),
      i === this.mainDetailsToggle
        ? (n && t.preventDefault(),
          n ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e),
          window.matchMedia("(max-width: 990px)") &&
            document.documentElement.style.setProperty(
              "--viewport-height",
              window.innerHeight + "px",
            ))
        : setTimeout(() => {
            if (
              Array.from(e.classList).includes("focus-inset") &&
              Array.from(e.classList).includes("mobile-facets__summary") &&
              window.matchMedia("(max-width: 990px)").matches
            ) {
              this.querySelectorAll("summary").forEach((el) => {
                if (Array.from(el.classList).includes("focus-inset")) {
                  el.parentNode.classList.remove("menu-opening");
                  el.parentNode.removeAttribute("open");
                  el.setAttribute("aria-expanded", "false");
                }
              });
              (i.classList.add("menu-opening"),
                i.setAttribute("open", ""),
                e.setAttribute("aria-expanded", "true"),
                s && s.classList.add("submenu-open"),
                !r || r.matches
                  ? o()
                  : e.nextElementSibling.addEventListener("transitionend", o));
            } else {
              (i.classList.add("menu-opening"),
                e.setAttribute("aria-expanded", !0),
                s && s.classList.add("submenu-open"),
                !r || r.matches
                  ? o()
                  : e.nextElementSibling.addEventListener("transitionend", o));
            }
          }, 100));
  }
  openMenuDrawer(t) {
    document.getElementsByTagName("sticky-header")[0].style.display = "none";
    document.getElementsByClassName("haptik-icon")[0].style.zIndex = 1;
    document.getElementsByClassName("utility-bar")[0].style.display = "none";
    Array.from(document.getElementsByClassName("active-facets-mobile")).forEach(
      (el) => {
        el.style.display = "none";
      },
    );
    (setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      t.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, t),
      document.body.classList.add("overflow-hidden-" + this.dataset.breakpoint),
      (document.getElementsByClassName("facets-wrapper")[0].style.zIndex =
        "999"));
    const retailFacetsWrapper = document.getElementsByClassName(
      "retail-facets-wrapper",
    )[0];
    if (retailFacetsWrapper) {
      retailFacetsWrapper.style.zIndex = "999";
      retailFacetsWrapper.querySelectorAll("details").forEach((t) => {
        t.classList.add("menu-opening");
      });
    }
  }
  closeMenuDrawer(t, e = !1) {
    if (void 0 === t) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    if (!window.matchMedia("(max-width: 990px)").matches) {
      this.mainDetailsToggle.querySelectorAll("details").forEach((t) => {
        (t.removeAttribute("open"), t.classList.remove("menu-opening"));
      });
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((t) => {
        t.classList.remove("submenu-open");
      });
    }
    (document.body.classList.remove(
      "overflow-hidden-" + this.dataset.breakpoint,
    ),
      removeTrapFocus(e),
      this.closeAnimation(this.mainDetailsToggle),
      t instanceof KeyboardEvent && e?.setAttribute("aria-expanded", !1));
    const i = document.getElementsByClassName("facets-wrapper");
    i.length > 0 && (i[0].style.zIndex = "2");
    if (document.getElementsByClassName("retail-facets-wrapper")[0]) {
      document.getElementsByClassName("retail-facets-wrapper")[0].style.zIndex =
        "2";
    }
    Array.from(document.getElementsByClassName("active-facets-mobile")).forEach(
      (el) => {
        el.style.display = "flex";
      },
    );
    document.getElementsByTagName("sticky-header")[0].style.display = "block";
    document.getElementsByClassName("utility-bar")[0].style.display = "block";
    document.getElementsByClassName("haptik-icon")[0].style.zIndex = 10;
  }
  onFocusOut() {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(t) {
    const e = t.currentTarget.closest("details");
    (this.closeSubmenu(e),
      (document.getElementsByClassName("facets-wrapper")[0].style.zIndex = "2"),
      document.body.classList.remove(
        "overflow-hidden-" + this.dataset.breakpoint,
      ));
    if (document.getElementsByClassName("retail-facets-wrapper")[0]) {
      document.getElementsByClassName("retail-facets-wrapper")[0].style.zIndex =
        "2";
    }
    Array.from(document.getElementsByClassName("active-facets-mobile")).forEach(
      (el) => {
        el.style.display = "flex";
      },
    );
    document.getElementsByTagName("sticky-header")[0].style.display = "block";
    document.getElementsByClassName("utility-bar")[0].style.display = "block";
    document.getElementsByClassName("haptik-icon")[0].style.zIndex = 10;
  }
  closeSubmenu(t) {
    const e = t.closest(".submenu-open");
    (e && e.classList.remove("submenu-open"),
      t.classList.remove("menu-opening"),
      t.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(t.querySelector("summary")),
      this.closeAnimation(t));
  }
  closeAnimation(t) {
    let e;
    const i = (s) => {
      (void 0 === e && (e = s),
        s - e < 400
          ? window.requestAnimationFrame(i)
          : (t.removeAttribute("open"),
            t.closest("details[open]") &&
              trapFocus(
                t.closest("details[open]"),
                t.querySelector("summary"),
              )));
    };
    window.requestAnimationFrame(i);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(t) {
    Array.from(document.getElementsByClassName("active-facets-mobile")).forEach(
      (el) => {
        el.style.display = "none";
      },
    );
    ((this.header = this.header || document.querySelector(".section-header")),
      (this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom",
        )
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        ) + "px",
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      t.setAttribute("aria-expanded", !0),
      window.addEventListener("resize", this.onResize),
      trapFocus(this.mainDetailsToggle, t),
      document.body.classList.add(
        "overflow-hidden-" + this.dataset.breakpoint,
      ));
  }
  closeMenuDrawer(t, e) {
    e &&
      (super.closeMenuDrawer(t, e),
      this.header.classList.remove("menu-open"),
      window.removeEventListener("resize", this.onResize));
  }
  onResize = () => {
    (this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        ) + "px",
      ),
      document.documentElement.style.setProperty(
        "--viewport-height",
        window.innerHeight + "px",
      ));
  };
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    (super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, !1),
      ),
      this.addEventListener("keyup", (t) => {
        "ESCAPE" === t.code.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (t) => {
            "mouse" !== t.pointerType ||
              t.target.closest("deferred-media, product-model") ||
              this.hide();
          })
        : this.addEventListener("click", (t) => {
            t.target === this && this.hide();
          }));
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(t) {
    this.openedBy = t;
    const e = this.querySelector(".template-popup");
    (document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      e && e.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia());
  }
  hide() {
    (document.body.classList.remove("overflow-hidden"),
      document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia());
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const t =
      this.querySelector("button") || this.querySelector("#open-prod-modal");
    t &&
      t.addEventListener("click", () => {
        const e = document.querySelector(this.getAttribute("data-modal"));
        e && e.show(t);
      });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const t = this.querySelector('[id^="Deferred-Poster-"]');
    t && t.addEventListener("click", this.loadContent.bind(this));
    this.enable_autoplay = this.querySelector("#autoplay-value")
      ? this.querySelector("#autoplay-value").value
      : null;
    if (this.enable_autoplay) t.click();
  }
  loadContent(t = !0) {
    if (
      (this.enable_autoplay || window.pauseAllMedia(),
      !this.getAttribute("loaded"))
    ) {
      const e = document.createElement("div");
      (e.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0),
      ),
        this.setAttribute("loaded", !0));
      const i = this.appendChild(
        e.querySelector("video, model-viewer, iframe"),
      );
      (t && i.focus(),
        "VIDEO" == i.nodeName && i.getAttribute("autoplay") && i.play());
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    (super(), this.initSlider());
  }
  initSlider() {
    ((this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(
        ".slider-counter--current",
      )),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      this.slider &&
        this.nextButton &&
        !this.hasAttribute("data-gallery-swipe") &&
        (this.initPages(),
        new ResizeObserver((t) => this.initPages()).observe(this.slider),
        this.slider.addEventListener("scroll", this.update.bind(this)),
        this.prevButton.addEventListener(
          "click",
          this.onButtonClick.bind(this),
        ),
        this.nextButton.addEventListener(
          "click",
          this.onButtonClick.bind(this),
        )));
  }
  initPages() {
    ((this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (t) => t.clientWidth > 0,
    )),
      this.sliderItemsToShow.length < 2 ||
        ((this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft -
          this.sliderItemsToShow[0].offsetLeft),
        (this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
            this.sliderItemOffset,
        )),
        (this.totalPages =
          this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update()));
  }
  resetPages() {
    ((this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      this.initPages());
  }
  update() {
    if (!this.slider || !this.nextButton) return;
    const t = this.currentPage;
    ((this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != t &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        ),
      this.enableSliderLooping ||
        (this.isSlideVisible(this.sliderItemsToShow[0]) &&
        0 === this.slider.scrollLeft
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
        )
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled")));
  }
  isSlideVisible(t, e = 0) {
    if (t) {
      const i = this.slider.clientWidth + this.slider.scrollLeft - e;
      return (
        t.offsetLeft + t.clientWidth <= i &&
        t.offsetLeft >= this.slider.scrollLeft
      );
    }
  }
  onButtonClick(t) {
    t.preventDefault();
    const e = t.currentTarget.dataset.step || 1;
    ((this.slideScrollPosition =
      "next" === t.currentTarget.name
        ? this.slider.scrollLeft + e * this.sliderItemOffset
        : this.slider.scrollLeft - e * this.sliderItemOffset),
      this.setSlidePosition(this.slideScrollPosition));
  }
  setSlidePosition(t) {
    this.slider.scrollTo({ left: t });
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    (super(),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      (this.enableSliderLooping = !0),
      this.sliderControlWrapper &&
        ((this.sliderFirstItemNode =
          this.slider.querySelector(".slideshow__slide")),
        this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
        (this.announcementBarSlider = this.querySelector(
          ".announcement-bar-slider",
        )),
        (this.announcerBarAnimationDelay = this.announcementBarSlider
          ? 250
          : 0),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
        )),
        this.sliderControlLinksArray.forEach((t) =>
          t.addEventListener("click", this.linkToSlide.bind(this)),
        ),
        this.slider.addEventListener(
          "scroll",
          this.setSlideVisibility.bind(this),
        ),
        this.setSlideVisibility(),
        this.announcementBarSlider &&
          ((this.announcementBarArrowButtonWasClicked = !1),
          (this.reducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
          )),
          this.reducedMotion.addEventListener("change", () => {
            "true" === this.slider.getAttribute("data-autoplay") &&
              this.setAutoPlay();
          }),
          [this.prevButton, this.nextButton].forEach((t) => {
            t.addEventListener(
              "click",
              () => {
                this.announcementBarArrowButtonWasClicked = !0;
              },
              { once: !0 },
            );
          })),
        "true" === this.slider.getAttribute("data-autoplay") &&
          this.setAutoPlay()));
  }
  setAutoPlay() {
    ((this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.querySelector(".slideshow__autoplay")
        ? ((this.sliderAutoplayButton = this.querySelector(
            ".slideshow__autoplay",
          )),
          this.sliderAutoplayButton.addEventListener(
            "click",
            this.autoPlayToggle.bind(this),
          ),
          (this.autoplayButtonIsSetToPlay = !0),
          this.play())
        : this.reducedMotion.matches ||
            this.announcementBarArrowButtonWasClicked
          ? this.pause()
          : this.play());
  }
  onButtonClick(t) {
    (super.onButtonClick(t), (this.wasClicked = !0));
    const e = 1 === this.currentPage,
      i = this.currentPage === this.sliderItemsToShow.length;
    e || i
      ? (e && "previous" === t.currentTarget.name
          ? (this.slideScrollPosition =
              this.slider.scrollLeft +
              this.sliderFirstItemNode.clientWidth *
                this.sliderItemsToShow.length)
          : i &&
            "next" === t.currentTarget.name &&
            (this.slideScrollPosition = 0),
        this.setSlidePosition(this.slideScrollPosition),
        this.applyAnimationToAnnouncementBar(t.currentTarget.name))
      : this.applyAnimationToAnnouncementBar(t.currentTarget.name);
  }
  setSlidePosition(t) {
    (this.setPositionTimeout && clearTimeout(this.setPositionTimeout),
      (this.setPositionTimeout = setTimeout(() => {
        this.slider.scrollTo({ left: t });
      }, this.announcerBarAnimationDelay)));
  }
  update() {
    (super.update(),
      (this.sliderControlButtons = this.querySelectorAll(
        ".slider-counter__link",
      )),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((t) => {
          (t.classList.remove("slider-counter__link--active"),
            t.removeAttribute("aria-current"));
        }),
        this.sliderControlButtons[this.currentPage - 1] &&
          this.sliderControlButtons[this.currentPage - 1].classList.add(
            "slider-counter__link--active",
          ),
        this.sliderControlButtons[this.currentPage - 1] &&
          this.sliderControlButtons[this.currentPage - 1].setAttribute(
            "aria-current",
            !0,
          )));
  }
  autoPlayToggle() {
    (this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay));
  }
  focusOutHandling(t) {
    if (this.sliderAutoplayButton) {
      const e =
        t.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(t.target);
      if (!this.autoplayButtonIsSetToPlay || e) return;
      this.play();
    } else
      this.reducedMotion.matches ||
        this.announcementBarArrowButtonWasClicked ||
        this.play();
  }
  focusInHandling(t) {
    this.sliderAutoplayButton
      ? (t.target === this.sliderAutoplayButton ||
          this.sliderAutoplayButton.contains(t.target)) &&
        this.autoplayButtonIsSetToPlay
        ? this.play()
        : this.autoplayButtonIsSetToPlay && this.pause()
      : this.announcementBarSlider.contains(t.target) && this.pause();
  }
  play() {
    (this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(
        this.autoRotateSlides.bind(this),
        this.autoplaySpeed,
      )));
  }
  pause() {
    (this.slider.setAttribute("aria-live", "polite"),
      clearInterval(this.autoplay));
  }
  togglePlayButtonState(t) {
    t
      ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.playSlideshow,
        ))
      : (this.sliderAutoplayButton.classList.remove(
          "slideshow__autoplay--paused",
        ),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.pauseSlideshow,
        ));
  }
  autoRotateSlides() {
    const t =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;
    (this.setSlidePosition(t), this.applyAnimationToAnnouncementBar());
  }
  setSlideVisibility(t) {
    (this.sliderItemsToShow.forEach((t, e) => {
      const i = t.querySelectorAll("a");
      e === this.currentPage - 1
        ? (i.length &&
            i.forEach((t) => {
              t.removeAttribute("tabindex");
            }),
          t.setAttribute("aria-hidden", "false"),
          t.removeAttribute("tabindex"))
        : (i.length &&
            i.forEach((t) => {
              t.setAttribute("tabindex", "-1");
            }),
          t.setAttribute("aria-hidden", "true"),
          t.setAttribute("tabindex", "-1"));
    }),
      (this.wasClicked = !1));
  }
  applyAnimationToAnnouncementBar(t = "next") {
    if (!this.announcementBarSlider) return;
    const e = this.sliderItems.length,
      i = "next" === t ? 1 : -1,
      s = this.currentPage - 1;
    let n = (s + i) % e;
    n = -1 === n ? e - 1 : n;
    const r = this.sliderItems[n],
      o = this.sliderItems[s],
      a = "announcement-bar-slider--fade-in",
      l = "announcement-bar-slider--fade-out",
      d =
        ("next" === t && s !== e - 1) || ("previous" === t && 0 === s)
          ? "next"
          : "previous";
    (o.classList.add(`${l}-${d}`),
      r.classList.add(`${a}-${d}`),
      setTimeout(() => {
        (o.classList.remove(`${l}-${d}`), r.classList.remove(`${a}-${d}`));
      }, 2 * this.announcerBarAnimationDelay));
  }
  linkToSlide(t) {
    t.preventDefault();
    const e =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(t.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({ left: e });
  }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    (super(), this.addEventListener("change", this.onVariantChange));
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(!0, "", !1);
    this.toggeBuyButton(!0, "", !1);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (this.currentVariant) {
      try {
        this.updateMedia();
      } catch (error) {
        console.error(error);
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    } else {
      this.toggleAddButton(!0, "", !0);
      this.setUnavailable();
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (t) => t.value);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1),
    );
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    document
      .querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
      .forEach((t) => {
        if (typeof t.setActiveMedia !== "function") return;
        t.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          !0,
        );
      });
    const t = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!t) return;
    const e = t.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    if (e) t.prepend(e);
  }
  updateURL() {
    this.currentVariant &&
      "false" !== this.dataset.updateUrl &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
  }
  updateShareUrl() {
    const t = document.getElementById("Share-" + this.dataset.section);
    t &&
      t.updateUrl &&
      t.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
  }
  updateVariantInput() {
    document
      .querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
      )
      .forEach((t) => {
        const e = t.querySelector('input[name="id"]');
        ((e.value = this.currentVariant.id),
          e.dispatchEvent(new Event("change", { bubbles: !0 })));
      });
  }
  updateVariantStatuses() {
    const t = this.variantData.filter(
        (t) => this.querySelector(":checked").value === t.option1,
      ),
      e = [...this.querySelectorAll(".product-form__input")];
    e.forEach((i, s) => {
      if (0 === s) return;
      const n = [...i.querySelectorAll('input[type="radio"], option')],
        r = e[s - 1].querySelector(":checked").value,
        o = t
          .filter((t) => t.available && t["option" + s] === r)
          .map((t) => t["option" + (s + 1)]);
      this.setInputAvailability(n, o);
    });
  }
  setInputAvailability(t, e) {
    t.forEach((t) => {
      e.includes(t.getAttribute("value"))
        ? (t.innerText = t.getAttribute("value"))
        : (t.innerText = window.variantStrings.unavailable_with_option.replace(
            "[value]",
            t.getAttribute("value"),
          ));
    });
  }
  updatePickupAvailability() {
    const t = document.querySelector("pickup-availability");
    t &&
      (this.currentVariant && this.currentVariant.available
        ? t.fetchAvailability(this.currentVariant.id)
        : (t.removeAttribute("available"), (t.innerHTML = "")));
  }
  removeErrorMessage() {
    const t = this.closest("section");
    if (!t) return;
    const e = t.querySelector("product-form");
    e && e.handleErrorMessage();
  }
  renderProductInfo() {
    const t = this.currentVariant.id,
      e = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${t}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((t) => t.text())
      .then((i) => {
        if (this.currentVariant.id !== t) return;
        const isQuickAddModal = Boolean(this.closest("quick-add-modal"));
        if (
          !isQuickAddModal &&
          (this.currentVariant.name.includes("Anklet") ||
            this.currentVariant.name.includes("Stud For Him") ||
            this.currentVariant.name.includes("Stud For Men"))
        ) {
          let code = "";
          let prodPriority = 0;
          let prodText = "";
          let prodDiscount = 0;
          const collections = Array.isArray(window.validCollection)
            ? window.validCollection
            : [];
          collections.forEach((item) => {
            if (this.currentVariant.price / 100 >= item.minimumVal) {
              if (
                this.currentVariant.price / 100 <= item.maximumVal ||
                item.maximumVal == 0
              ) {
                if (code == "" || item.priority > prodPriority) {
                  code = item.code;
                  prodText = item.pdpText;
                  prodPriority = item.priority;
                  prodDiscount =
                    item.discountType == "percentage"
                      ? this.currentVariant.price / 100 -
                        (this.currentVariant.price / 100) *
                          (item.discountValue / 100)
                      : this.currentVariant.price / 100 - item.discountValue;
                }
              }
            }
          });
          const bestPriceBox = document.getElementById("best-price-main-box");
          if (bestPriceBox) {
            if (prodText.length > 0) {
              if (prodText.includes("{price}")) {
                bestPriceBox.innerHTML = `${prodText.split("{price}")[0]}<span id="best-price-main">₹${parseInt(prodDiscount).toLocaleString("en-US")}</span>${prodText.split("{price}")[1].split("{coupon}")[0]}<span id="best-price-coupon">${code}</span>`;
              } else {
                bestPriceBox.innerHTML = `<span id="best-price-main">${prodText.split("{coupon}")[0]}</span> <span id="best-price-coupon">${code}</span>`;
              }
            } else {
              bestPriceBox.innerHTML = "";
            }
          }
          if (
            window.matchMedia("(max-width: 750px)").matches &&
            typeof setContainerHeight === "function"
          ) {
            setContainerHeight("true");
          }
        }
        const s = new DOMParser().parseFromString(i, "text/html"),
          n = document.getElementById("price-" + this.dataset.section),
          r = s.getElementById(
            "price-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          o = s.getElementById(
            "Sku-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          a = document.getElementById("Sku-" + this.dataset.section),
          l = s.getElementById(
            "Inventory-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          d = document.getElementById("Inventory-" + this.dataset.section),
          u = s.getElementById(
            "Volume-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          c = document.getElementById("Price-Per-Item-" + this.dataset.section),
          h = s.getElementById(
            "Price-Per-Item-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          m = document.getElementById("Volume-" + this.dataset.section);
        (r && n && (n.innerHTML = r.innerHTML),
          l && d && (d.innerHTML = l.innerHTML),
          o &&
            a &&
            ((a.innerHTML = o.innerHTML),
            a.classList.toggle(
              "visibility-hidden",
              o.classList.contains("visibility-hidden"),
            )),
          u && m && (m.innerHTML = u.innerHTML),
          h &&
            c &&
            ((c.innerHTML = h.innerHTML),
            c.classList.toggle(
              "visibility-hidden",
              h.classList.contains("visibility-hidden"),
            )));
        const p = document.getElementById("price-" + this.dataset.section);
        (p && p.classList.remove("visibility-hidden"),
          d &&
            l &&
            d.classList.toggle("visibility-hidden", "" === l.innerText));
        const y = s.getElementById("ProductSubmitButton-" + e),
          g = s.getElementById("ProductBuyButton-" + e);
        const shouldDisableAdd = y
          ? y.hasAttribute("disabled")
          : !this.currentVariant.available;
        const shouldDisableBuy = g
          ? g.hasAttribute("disabled") || g.style.display === "none"
          : !this.currentVariant.available;
        (this.toggleAddButton(
          shouldDisableAdd,
          shouldDisableAdd ? window.variantStrings.soldOut : "",
        ),
          this.toggeBuyButton(
            shouldDisableBuy,
            shouldDisableBuy ? window.variantStrings.soldOut : "",
          ),
          publish(PUB_SUB_EVENTS.variantChange, {
            data: { sectionId: e, html: s, variant: this.currentVariant },
          }));
      })
      .catch((error) => {
        console.error(error);
        if (!this.currentVariant) return;
        this.toggleAddButton(
          !this.currentVariant.available,
          this.currentVariant.available ? "" : window.variantStrings.soldOut,
        );
        this.toggeBuyButton(
          !this.currentVariant.available,
          this.currentVariant.available ? "" : window.variantStrings.soldOut,
        );
      });
  }
  toggleAddButton(t = !0, e) {
    const i = document.getElementById("product-form-" + this.dataset.section);
    if (!i) return;
    const s = i.querySelector('[name="add"]'),
      n = i.querySelector('[name="add"] > span');
    if (!s) return;
    if (t) {
      s.setAttribute("disabled", "disabled");
      if (e && n) n.textContent = e;
    } else {
      s.removeAttribute("disabled");
      if (n && !n.querySelector("svg")) {
        n.textContent = window.variantStrings.addToCart;
      }
    }
  }
  toggeBuyButton(t = !0, e) {
    const i = document.getElementById("product-form-" + this.dataset.section);
    if (!i) return;
    const s = i.querySelector('[name="buy"]'),
      n = i.querySelector('[name="buy"] > span');
    if (!s) return;
    if (t) {
      s.setAttribute("disabled", "disabled");
      if (e && n) n.textContent = e;
    } else {
      s.removeAttribute("disabled");
      if (n && !n.querySelector("svg")) {
        n.textContent = window.variantStrings.buyNow;
      }
    }
  }
  setUnavailable() {
    const t = document.getElementById("product-form-" + this.dataset.section),
      e = t.querySelector('[name="add"]'),
      i = t.querySelector('[name="add"] > span'),
      s = document.getElementById("price-" + this.dataset.section),
      n = document.getElementById("Inventory-" + this.dataset.section),
      r = document.getElementById("Sku-" + this.dataset.section),
      o = document.getElementById("Price-Per-Item-" + this.dataset.section);
    e &&
      ((i.textContent = window.variantStrings.unavailable),
      s && s.classList.add("visibility-hidden"),
      n && n.classList.add("visibility-hidden"),
      r && r.classList.add("visibility-hidden"),
      o && o.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent,
        )),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  setInputAvailability(t, e) {
    t.forEach((t) => {
      e.includes(t.getAttribute("value"))
        ? t.classList.remove("disabled")
        : t.classList.add("disabled");
    });
  }
  updateOptions() {
    const t = Array.from(this.querySelectorAll("fieldset"));
    this.options = t.map(
      (t) =>
        Array.from(t.querySelectorAll("input")).find((t) => t.checked).value,
    );
  }
}
customElements.define("variant-radios", VariantRadios);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    new IntersectionObserver(
      ((t, e) => {
        t[0].isIntersecting &&
          (e.unobserve(this),
          fetch(this.dataset.url)
            .then((t) => t.text())
            .then((t) => {
              const e = document.createElement("div");
              e.innerHTML = t;
              const i = e.querySelector("product-recommendations");
              (i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML),
                !this.querySelector("slideshow-component") &&
                  this.classList.contains("complementary-products") &&
                  this.remove(),
                e.querySelector(".grid__item") &&
                  this.classList.add("product-recommendations--loaded"));
            })
            .catch((t) => {
              console.error(t);
            }));
      }).bind(this),
      { rootMargin: "0px 0px 400px 0px" },
    ).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

window.addEventListener("pageshow", async function (event) {
  if (event.persisted) {
    document
      .querySelector(".cart-notification-overlay.active")
      ?.classList.remove("active");
  }
  async function waitForShowCustomCart() {
    while (!localStorage.getItem("showCustomCart")) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    return localStorage.getItem("showCustomCart");
  }
  const showCustomCart = await waitForShowCustomCart();
  if (showCustomCart == "true") {
    setCartItemCount();
  }
});
